import { createSlice } from "@reduxjs/toolkit";

const paymentReducer = createSlice({
  name: "paymentButton",
  initialState: {
    clickPaymentButton: false,
  },
  reducers: {
    clickPaymentButton(state, action) {
      state.clickPaymentButton = action.payload;
    },
  },
});

export const { clickPaymentButton } = paymentReducer.actions;
export default paymentReducer.reducer;
